export const Theme = {
  typography: {
    fontFamily: ["ProximaNovaAltLight-Regular"],
  },
  palette: {
    primary: {
      main: "#008952",
    },
    light: {
      main: "white",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        // maxWidth: 300
      },
      containedPrimary: {
        color: "#fff",
      },
      text: {
        color: "#008952",
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 30,
      },
    },
    MuiTypography: {
      colorTextSecondary: {
        color: "#fff",
      },
    },
  },
};
